// Analytics helper: fires events to both Google Analytics (gtag) and our internal /api/events.
// - gtag lives in public/index.html and auto-tracks pageviews via enhanced measurement.
// - For explicit SPA route tracking, call trackPageview(path) on route change.
// - For user actions, call trackEvent('button_click', { button_name: 'Upgrade' }).

import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function gtagSafe(...args) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    try { window.gtag(...args); } catch (_) { /* noop */ }
  }
}

/** Fire a pageview to GA on SPA route change. */
export function trackPageview(path) {
  gtagSafe('event', 'page_view', {
    page_path: path,
    page_location: typeof window !== 'undefined' ? window.location.href : path,
  });
  // also log server-side for our internal analytics
  axios.post(`${API}/events`, {
    event_type: 'page_view',
    metadata: { path },
  }).catch(() => {});
}

/** Fire a custom event to both GA and our internal API. */
export function trackEvent(eventType, metadata = {}) {
  gtagSafe('event', eventType, metadata);
  axios.post(`${API}/events`, {
    event_type: eventType,
    metadata,
  }).catch(() => {});
}

export function trackButton(buttonName, extra = {}) {
  trackEvent('button_click', { button_name: buttonName, ...extra });
}

export function trackPaywallView(source = 'unknown') {
  trackEvent('paywall_view', { source });
}
